
import React, { useState } from 'react'
import { Col, Nav, Tab } from 'react-bootstrap'

import { useTeams } from '@/Hooks/UseTeam'

import ActiveUsers from './ActiveUsers'
import ButtonAddMember from '../ButtonAddMember/ButtonAddMember'
import ButtonAddTeam from '../ButtonAddTeam/ButtonAddTeam'
import InternalProfiles from './InternalProfiles'
import PendingInvites from './PendingInvites'
import TeamSettings from './TeamSettings'

import './RightSelectedTeam.scss'

const RightSelectedTeam = () => {

  const { teamSelected } = useTeams()

  const [ tab, setTab ] = useState<'users' | 'settings'>('users')

  return (
    <Col lg={8} xl={9} className="teams-right-side">
      <Tab.Container>
        <div className='selected-team-header'>
          <span className='team-name'>
            {teamSelected?.name}
          </span>
          <div className='header-right-buttons'>
            {tab === 'users' && (
              <>
                <ButtonAddTeam className='d-none d-lg-flex' />
                {teamSelected && (
                  <ButtonAddMember />
                )}
              </>
            )}

            {teamSelected && (
              <Nav variant='pills' className='teams-navbar'>
                <Nav.Item>
                  <Nav.Link active={tab === 'users'} onClick={() => setTab('users')}>
                    <span className="icon-grupo_equipo"></span>{" "}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link active={tab === 'settings'} onClick={() => setTab('settings')}>
                    <span className="icon-configuracion"></span>{" "}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            )}
          </div>
        </div>
      </Tab.Container>

      {teamSelected && (
        <Tab.Content className='selected-team-body scroller' style={{ height: 'auto', overflowX: 'hidden' }}>
          <Tab.Pane active={tab === 'users'} style={{ flex: 1 }}>
            <PendingInvites />
            <ActiveUsers />
            <InternalProfiles />
          </Tab.Pane>
          <Tab.Pane active={tab === 'settings'}>
            <TeamSettings />
          </Tab.Pane>
        </Tab.Content>
      )}
    </Col>
  )
}

export default RightSelectedTeam
